import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ThemeToggle from './ThemeToggle';
import Dashboard from './Dashboard';
import NotificationsPanel from './NotificationsPanel';

function DashboardPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Rediriger vers l'accueil si l'utilisateur n'a pas les permissions
  if (!['superviseur', 'manager'].includes(user?.role)) {
    navigate('/');
    return null;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Barre de navigation */}
      <div style={{
        background: '#9cb85c',
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #000'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <h1 style={{ margin: 0, color: 'white', fontSize: '24px' }}>
            📊 Dashboard - 6W2H v2.0
          </h1>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.3)',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              📝 Formulaires
            </button>
            {['superviseur', 'manager'].includes(user?.role) && (
              <button
                onClick={() => navigate('/approvals')}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                ✅ Approbations
              </button>
            )}
          </div>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <NotificationsPanel />
          <span style={{ color: 'white', fontSize: '14px' }}>
            👤 {user?.prenom} {user?.nom} ({user?.role})
          </span>
          <button 
            onClick={logout}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.3)',
              padding: '8px 15px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Déconnexion
          </button>
        </div>
      </div>

      {/* Contenu Dashboard */}
      <Dashboard />

      {/* Footer avec informations */}
      <div style={{
        background: 'white',
        padding: '20px',
        textAlign: 'center',
        borderTop: '1px solid #dee2e6',
        color: '#6c757d',
        fontSize: '14px'
      }}>
        <p style={{ margin: '0 0 10px 0' }}>
          <strong>6W2H Dashboard v2.0</strong> - Analytics et reporting en temps réel
        </p>
        <p style={{ margin: 0 }}>
          Données mises à jour automatiquement • 
          Ligne B3 : 10 000€/h de coût d'arrêt • 
          Support technique : IT Department
        </p>
      </div>
    </div>
  );
}

export default DashboardPage;
